import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, Button, Typography } from '@mui/material';
import useOffSetTop from '../../../hooks/useOffSetTop';
import cssStyles from '../../../utils/cssStyles';
import { HEADER } from '../../../config';
import Logo from '../../../components/Logo';
import AccountPopover from './AccountPopover';
import PageOptions from './PageOptions';
import { useLocation } from 'react-router-dom';

type RootStyleProps = {
  isCollapse: boolean;
  isOffset: boolean;
  verticalLayout: boolean;
};

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) =>
    prop !== 'isCollapse' && prop !== 'isOffset' && prop !== 'verticalLayout',
})<RootStyleProps>(({ isCollapse, isOffset, verticalLayout, theme }) => ({
  ...cssStyles(theme).bgBlur(),
  width: `100%`,
  boxShadow: 'none',
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  backgroundColor: theme.palette.grey[100],
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
  },
}));

type Props = {
  isCollapse?: boolean;
  verticalLayout?: boolean;
};

export default function DashboardHeader({
  isCollapse = false,
  verticalLayout = false,
}: Props) {
  const isOffset = useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;
  const { pathname } = useLocation();

  return (
    <RootStyle isCollapse={isCollapse} isOffset={isOffset} verticalLayout={verticalLayout}>
      <Toolbar
        sx={{
          minHeight: '100% !important',
          px: { lg: 5 },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={7}>
          <Logo sx={{ width: 94, height: 35 }} />
          <PageOptions/>
        </Stack>
        <Box component='div' sx={{ flexGrow: 1 }} />
        <Stack direction="row" alignItems="center" spacing={{ xs: 4, sm: 5.5 }}>
          {!pathname?.includes('crm') &&
          <Box component='div' sx={{ flexGrow: 1 }}>
            <Button variant='contained' onClick={() => {window.open('http://wa.me/+555195272351')}}>
              <Typography variant="subtitle2">
                Suporte
              </Typography>
            </Button>
          </Box>}
          <AccountPopover />
        </Stack>
      </Toolbar>
    </RootStyle>
  );
}
